{#if accessLevels}
    {#if accessLevels.length > 1}
        <ul class="access-level-list">
            {#each accessLevels as accessLevel}
                <AccessLevelItem
                    accessLevel={accessLevel}
                    terms={terms}
                    accessLevelType={accessLevelType}
                    password={password}
                    groupName='accessLevelList'
                    on:change={onAccessLevelChanged} />
            {/each}
        </ul>
    {:else if accessLevels.length === 1}
        <span>{accessLevels[0].title}</span>
    {/if}
{/if}

<script>
    import { createEventDispatcher } from 'svelte';

    import AccessLevelItem from './AccessLevelItem.svelte';
    
	const dispatch = createEventDispatcher();

    export let password = '';
    export let accessLevelType = 0;
    export let accessLevels = [];
    export let terms = {};
    
    function onAccessLevelChanged(event) {
        accessLevelType = event.detail.accessLevelType;
        password = event.detail.password;

        dispatch('change', event.detail);
    }
</script>